/* ============================================================
   THÉ MAYA — Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initMegaMenus();
  initMobileMenu();
  initMobileAccordions();
  initCartDrawer();
  initProductGallery();
  initQuantityInputs();
  updateCartCount();
  initStickyHeader();
  initProductCardVariants();
  initPredictiveSearch();
  initCartPage();
  initProductFaq();
});

/* ── Sticky Header shadow on scroll ─────────────────────────── */
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
}

/* ── Mobile Menu ─────────────────────────────────────────────── */
function initMobileMenu() {
  const btn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.mobile-nav');
  const close = document.querySelector('.mobile-nav-close');
  const overlay = document.querySelector('.mobile-nav-overlay');
  if (!btn || !nav) return;

  const openMenu = () => {
    nav.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    btn.setAttribute('aria-expanded', 'true');
  };

  const closeMenu = () => {
    nav.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    btn.setAttribute('aria-expanded', 'false');
  };

  btn.addEventListener('click', openMenu);
  if (close) close.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) closeMenu();
  });
}

/* ── Mega-menu (hover to open) ───────────────────────────────── */
function initMegaMenus() {
  const navItems = document.querySelectorAll('.nav-item--has-dropdown');
  const CLOSE_DELAY = 150; // ms avant fermeture — laisse le temps d'atteindre le menu

  navItems.forEach(item => {
    let closeTimer = null;

    const open = () => {
      clearTimeout(closeTimer);
      navItems.forEach(other => { if (other !== item) other.classList.remove('is-open'); });
      item.classList.add('is-open');
    };

    const scheduleClose = () => {
      closeTimer = setTimeout(() => item.classList.remove('is-open'), CLOSE_DELAY);
    };

    // Survol du li parent (couvre le lien ET le mega-menu)
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);

    // Le lien reste cliquable sur desktop (navigation normale)
    const link = item.querySelector('.nav-item__link');
    if (link) {
      // Sur touch : toggle au tap (pas de hover sur mobile)
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          const isOpen = item.classList.contains('is-open');
          navItems.forEach(other => other.classList.remove('is-open'));
          item.classList.toggle('is-open', !isOpen);
        }
      });
    }
  });

  // Fermer si on clique en dehors (touch fallback)
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-item--has-dropdown')) {
      navItems.forEach(item => item.classList.remove('is-open'));
    }
  });

  // Fermer avec Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      navItems.forEach(item => item.classList.remove('is-open'));
    }
  });
}

/* ── Mobile Nav Accordion ────────────────────────────────────── */
function initMobileAccordions() {
  document.querySelectorAll('[data-accordion]').forEach(accordion => {
    const btn = accordion.querySelector('[data-accordion-btn]');
    const body = accordion.querySelector('.mobile-nav-accordion__body');
    if (!btn || !body) return;

    btn.addEventListener('click', () => {
      const isOpen = accordion.classList.contains('is-open');
      // Close all other accordions
      document.querySelectorAll('[data-accordion].is-open').forEach(other => {
        if (other !== accordion) {
          other.classList.remove('is-open');
          other.querySelector('[data-accordion-btn]').setAttribute('aria-expanded', 'false');
        }
      });
      // Toggle current
      accordion.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
}

/* ── Cart Drawer ─────────────────────────────────────────────── */
function initCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const overlay = drawer.querySelector('.cart-drawer__overlay');
  const closeBtn = drawer.querySelector('.cart-drawer__close');

  document.querySelectorAll('[data-open-cart]').forEach(btn => {
    btn.addEventListener('click', openCartDrawer);
  });

  if (overlay) overlay.addEventListener('click', closeCartDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeCartDrawer();
    }
  });
}

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  refreshCartDrawer();
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

async function refreshCartDrawer() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    renderCartDrawer(cart);
  } catch (e) {
    console.error('Cart fetch error:', e);
  }
}

function renderCartDrawer(cart) {
  const body = document.getElementById('cart-drawer-body');
  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <p>Votre panier est vide.</p>
        <a href="/collections/all" class="btn btn-primary" onclick="closeCartDrawer()">Découvrir nos produits</a>
      </div>`;
    return;
  }

  /* ── Barre gamification -10% ── */
  const discountThreshold = 3;
  const itemCount = cart.item_count;
  const discountReached = itemCount >= discountThreshold;
  const discountLeft = Math.max(0, discountThreshold - itemCount);

  const stepsHtml = [1, 2, 3].map(i => {
    const filled = itemCount >= i ? ' is-filled' : '';
    const connectorFilled = itemCount > i ? ' is-filled' : '';
    const stepSvg = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V8z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/><line x1="14" y1="2" x2="14" y2="4"/></svg>`;
    return `
      <div class="discount-progress__step${filled}" data-step="${i}">
        <div class="discount-progress__step-dot">${stepSvg}</div>
        <span class="discount-progress__step-label">${i}</span>
      </div>
      ${i < 3 ? `<div class="discount-progress__connector${connectorFilled}" data-connector="${i}"></div>` : ''}
    `;
  }).join('');

  const discountLabel = discountReached
    ? `<span class="discount-label--active">Votre remise de <strong>-10%</strong> est appliquée automatiquement !</span>`
    : `Encore <strong>${discountLeft} article${discountLeft > 1 ? 's' : ''}</strong> pour <strong>-10%</strong> sur votre commande`;

  const discountBadgeClass = discountReached ? ' is-active' : '';

  /* ── Barre livraison ── */
  const shippingThreshold = 5000; // 50€ en centimes
  const freeShipAll = !!window._freeShipAll; // opération week-end : livraison offerte sur tout le panier
  const shippingPct = freeShipAll ? 100 : Math.min(100, Math.round((cart.total_price / shippingThreshold) * 100));
  const shippingLeft = Math.max(0, shippingThreshold - cart.total_price);
  const shippingLabel = freeShipAll
    ? `<span class="shipping-label--free">Livraison offerte sur <strong>toute votre commande</strong> ce week-end !</span>`
    : (shippingPct >= 100
      ? `<span class="shipping-label--free">🎉 Vous bénéficiez de la <strong>livraison offerte</strong> !</span>`
      : `Plus que <strong>${formatMoney(shippingLeft)}</strong> pour la <strong>livraison offerte</strong>`);

  /* ── Articles ── */
  const itemsHtml = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item__image">
        <img src="${item.image ? item.image.replace('.jpg', '_160x.jpg') : ''}" alt="${item.product_title}">
      </div>
      <div class="cart-item__info">
        <p class="cart-item__title">${item.product_title}</p>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
        <div class="cart-item__qty">
          <button class="qty-change" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
          <span>${item.quantity}</span>
          <button class="qty-change" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
        </div>
      </div>
      <div class="cart-item__price">
        ${item.original_line_price > item.line_price
          ? `<s class="cart-item__original-price">${formatMoney(item.original_line_price)}</s>`
          : ''}
        <span class="cart-item__final-price${item.original_line_price > item.line_price ? ' cart-item__final-price--deal' : ''}">${formatMoney(item.line_price)}</span>
      </div>
    </div>
  `).join('');

  body.innerHTML = `
    ${freeShipAll ? `
    <div class="cart-drawer-freeship">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
      <span>Livraison offerte sur <strong>toute votre commande</strong> ce week-end !</span>
    </div>` : ''}
    <div class="cart-drawer-gamification">

      <!-- Remise -10% (masquée pour CSE et Pro) -->
      ${!window._hideGamif ? `
      <div class="discount-progress discount-progress--drawer" data-discount-progress data-item-count="${itemCount}">
        <div class="discount-progress__header">
          <div class="discount-progress__steps" data-discount-steps>${stepsHtml}</div>
          <div class="discount-progress__badge${discountBadgeClass}" data-discount-badge>-10%</div>
        </div>
        <p class="discount-progress__label" data-discount-label>${discountLabel}</p>
      </div>` : ''}

      <!-- Livraison offerte -->
      <div class="shipping-progress shipping-progress--in-summary shipping-progress--drawer" data-shipping-progress>
        <div class="shipping-progress__track">
          <div class="shipping-progress__fill" style="width:${shippingPct}%"></div>
        </div>
        <p class="shipping-progress__label">${shippingLabel}</p>
      </div>

    </div>

    <div class="cart-items">${itemsHtml}</div>

    <div class="cart-footer">
      <div class="cart-subtotal">
        <span>Sous-total</span>
        <span>${formatMoney(cart.total_price)}</span>
      </div>
      <a href="/checkout" class="btn btn-primary product-atc-btn">Commander</a>
      <a href="/cart" class="btn btn-secondary product-atc-btn" style="margin-top:10px">Voir le panier</a>
    </div>`;

  body.querySelectorAll('.qty-change').forEach(btn => {
    btn.addEventListener('click', () => {
      updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty));
    });
  });

  updateCartCount(cart.item_count);
}

async function updateCartItem(key, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await response.json();
    renderCartDrawer(cart);
  } catch (e) {
    console.error('Cart update error:', e);
  }
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

async function updateCartCount(count) {
  const badge = document.querySelector('.cart-count');
  if (!badge) return;

  if (count === undefined) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      count = cart.item_count;
    } catch (e) { return; }
  }

  badge.textContent = count;
  badge.style.display = count > 0 ? 'flex' : 'none';
}

/* ── Add to Cart ─────────────────────────────────────────────── */
document.addEventListener('click', async (e) => {
  const atcBtn = e.target.closest('[data-atc]');
  if (!atcBtn) return;

  const variantId = atcBtn.dataset.atc;
  if (!variantId) return;

  const qtyInput = document.querySelector('.qty-input, .ube-qty-input');
  const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

  // Selling plan (abonnement) — valeur posée par l'app Shopify Subscriptions
  const sellingPlanInput =
    document.querySelector('.subscriptions_app_embed_block input[name="selling_plan"]') ||
    document.querySelector('input[name="selling_plan"]') ||
    document.getElementById('selected-selling-plan');
  const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : '';

  // Gravure prénom
  const prenomBlock = document.getElementById('prenom-block');
  const prenomInput = document.getElementById('prenom-input');
  const prenomValue = prenomInput ? prenomInput.value.trim() : '';
  if (prenomBlock && !prenomValue) {
    prenomInput.focus();
    prenomInput.classList.add('prenom-input--error');
    setTimeout(() => prenomInput.classList.remove('prenom-input--error'), 2000);
    return;
  }

  // Personnalisation bouteille
  const persoBlock     = document.getElementById('perso-block');
  const persoPanel     = document.getElementById('perso-panel');
  const persoText      = document.getElementById('perso-text');
  const persoFontBtn   = document.querySelector('.perso-font-btn.active');
  const persoEnabled   = persoBlock && persoPanel && !persoPanel.hidden;
  const persoValue     = persoText ? persoText.value.trim() : '';
  const persoFont      = persoFontBtn ? persoFontBtn.dataset.font  : '';
  const persoFontLabel = persoFontBtn ? (persoFontBtn.dataset.label || persoFontBtn.dataset.font) : '';

  // Validation personnalisation
  if (persoEnabled && !persoValue) {
    persoText.focus();
    persoText.classList.add('perso-text-input--error');
    setTimeout(() => persoText.classList.remove('perso-text-input--error'), 2000);
    return;
  }

  const originalHTML = atcBtn.innerHTML;
  atcBtn.textContent = 'Ajout…';
  atcBtn.disabled = true;

  // Construire les items à ajouter (produit principal + option perso si active)
  const mainItem = { id: variantId, quantity };
  if (sellingPlanId) mainItem.selling_plan = parseInt(sellingPlanId, 10);
  if (prenomBlock && prenomValue) {
    mainItem.properties = { 'Prénom à graver': prenomValue };
  }
  if (persoEnabled && persoValue) {
    mainItem.properties = {
      'Gravure'  : persoValue,
      'Police'   : persoFontLabel,
    };
  }

  const items = [mainItem];

  if (persoEnabled && persoValue) {
    items.push({
      id       : persoBlock.dataset.persoVariant,
      quantity : quantity,
      properties : {
        'Texte à graver' : persoValue,
        'Police'         : persoFontLabel,
      },
    });
  }

  try {
    const response = await fetch('/cart/add.js', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify({ items }),
    });
    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.description || 'Add to cart failed');
    }
    await response.json();
    atcBtn.textContent = '✓ Ajouté !';
    setTimeout(() => {
      atcBtn.innerHTML = originalHTML;
      atcBtn.disabled = false;
    }, 1500);
    openCartDrawer();
  } catch (err) {
    console.error(err);
    atcBtn.textContent = 'Erreur – Réessayer';
    atcBtn.disabled = false;
  }
});

/* ── Subscription app bridge ─────────────────────────────────── */
// L'app Shopify Subscriptions gère son propre widget dans .subscriptions_app_embed_block.
// Notre ATC lit directement l'input[name="selling_plan"] que l'app y injecte.

// ── 2. Masquer la phrase de disclaimer ──────────────────────────
(function () {
  var KEYWORDS = ['renouvellement est automatique', 'ignorer ou annuler'];

  function hideDisclaimer(root) {
    root = root || document.querySelector('.subscriptions_app_embed_block');
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.textContent || '';
      if (KEYWORDS.some(function (k) { return text.indexOf(k) !== -1; })) {
        var el = node.parentElement;
        while (el && el !== root) {
          // Remonter jusqu'à un bloc autonome (p, div, span seul sur sa ligne)
          if (el.children.length === 0 ||
              (el.tagName === 'P' || el.tagName === 'DIV' || el.tagName === 'SPAN')) {
            el.style.display = 'none';
            break;
          }
          el = el.parentElement;
        }
      }
    }
  }

  // Tenter immédiatement, puis après chargement de l'app (elle injecte en async)
  hideDisclaimer();
  setTimeout(hideDisclaimer, 400);
  setTimeout(hideDisclaimer, 1200);

  // Observer les injections tardives de l'app
  var embedBlock = document.querySelector('.subscriptions_app_embed_block');
  if (embedBlock && window.MutationObserver) {
    new MutationObserver(function () { hideDisclaimer(embedBlock); })
      .observe(embedBlock, { childList: true, subtree: true });
  }
})();

/* ── Product Gallery Carousel ────────────────────────────────── */
function initProductGallery() {
  const carousel = document.querySelector('.product-gallery__carousel');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('.product-gallery__slide');
  const dots   = carousel.querySelectorAll('.product-gallery__dot');
  const prev   = carousel.querySelector('.product-gallery__arrow--prev');
  const next   = carousel.querySelector('.product-gallery__arrow--next');
  if (!slides.length) return;

  let current = 0;

  function goTo(index) {
    slides[current].classList.remove('active');
    if (dots[current]) dots[current].classList.remove('active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
  }

  if (prev) prev.addEventListener('click', () => goTo(current - 1));
  if (next) next.addEventListener('click', () => goTo(current + 1));

  dots.forEach(dot => {
    dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index)));
  });

  // Swipe tactile
  let touchStartX = 0;
  carousel.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  carousel.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
  });
}

/* ── Product FAQ Accordion ───────────────────────────────────── */
function initProductFaq() {
  document.querySelectorAll('.product-faq__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item   = btn.closest('.product-faq__item');
      const answer = item.querySelector('.product-faq__answer');
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      // Ferme tous les autres
      item.closest('.product-faq__list').querySelectorAll('.product-faq__question').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        b.closest('.product-faq__item').querySelector('.product-faq__answer').classList.remove('is-open');
      });

      // Ouvre/ferme celui-ci
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        answer.classList.add('is-open');
      }
    });
  });
}

/* ── Quantity Inputs ─────────────────────────────────────────── */
function initQuantityInputs() {
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (btn.dataset.action === 'plus') val = val + 1;
      input.value = val;
    });
  });
}

/* ── Product Card Variant Selector ──────────────────────────── */
function initProductCardVariants() {
  document.querySelectorAll('[data-product-card]').forEach(card => {
    const track = card.querySelector('.product-card__variants-track');
    if (!track) return;

    const prevBtn = card.querySelector('.product-card__arr--prev');
    const nextBtn = card.querySelector('.product-card__arr--next');
    const priceEl = card.querySelector('[data-card-price]');
    const compareEl = card.querySelector('[data-card-compare]');
    const atcBtn = card.querySelector('[data-atc]');

    // Arrow scroll
    if (prevBtn) prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -90, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: 90, behavior: 'smooth' });
    });

    // Variant click
    track.querySelectorAll('.product-card__variant').forEach(btn => {
      btn.addEventListener('click', () => {
        track.querySelectorAll('.product-card__variant').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const price  = parseInt(btn.dataset.variantPrice) || 0;
        const compare = parseInt(btn.dataset.variantCompare) || 0;
        const available = btn.dataset.variantAvailable === 'true';
        const variantId = btn.dataset.variantId;

        const isCseCard = priceEl && priceEl.classList.contains('product-card__price--cse');
        if (isCseCard) {
          const csePrice = Math.round(price * 0.7);
          if (priceEl) priceEl.textContent = formatMoney(csePrice);
          if (compareEl) { compareEl.textContent = formatMoney(price); compareEl.style.display = ''; }
        } else {
          if (priceEl) priceEl.textContent = formatMoney(price);
          if (compareEl) {
            if (compare > price) {
              compareEl.textContent = formatMoney(compare);
              compareEl.style.display = '';
            } else {
              compareEl.textContent = '';
              compareEl.style.display = 'none';
            }
          }
        }
        if (atcBtn) {
          atcBtn.dataset.atc = variantId;
          atcBtn.disabled = !available;
          atcBtn.textContent = available ? 'AJOUTER' : 'RUPTURE DE STOCK';
        }
      });
    });
  });
}

/* ── FAQ Accordéon ───────────────────────────────────────────── */
(function () {
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
})();

/* ── Page Recherche ──────────────────────────────────────────── */
(function () {
  const sortSelect = document.querySelector('[data-search-sort]');
  if (!sortSelect) return;

  sortSelect.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
})();

/* ── Page Panier ─────────────────────────────────────────────── */
function initCartPage() {
  const page = document.querySelector('[data-cart-page]');
  if (!page) return;

  const threshold = parseInt(page.dataset.threshold || '5000', 10);

  /* Animer la barre de progression au chargement */
  animateShippingBar(threshold, window.__cartTotal || 0);

  /* Récupérer le total initial depuis la page */
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      animateShippingBar(threshold, cart.total_price);
      updateDiscountBar(cart.item_count);
      updateSummary(cart, threshold);
    });

  /* ── Changement de quantité ── */
  page.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (!qtyBtn) return;

    const key  = qtyBtn.dataset.cartQty;
    const qty  = parseInt(qtyBtn.dataset.qty, 10);
    if (isNaN(qty) || qty < 0) return;

    const item = page.querySelector(`[data-cart-item][data-key="${key}"]`);
    const line = item ? parseInt(item.dataset.line, 10) : NaN;
    if (item) item.classList.add('is-updating');

    /* Payload : on préfère line (1-based index, fiable) ; id en fallback */
    const payload = (!isNaN(line))
      ? { line, quantity: qty }
      : { id: key, quantity: qty };

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const cart = await res.json();

      if (!res.ok || !cart.items) {
        console.error('cart/change.js error:', cart);
        if (item) item.classList.remove('is-updating');
        return;
      }

      if (qty === 0) {
        /* Suppression avec animation */
        if (item) {
          item.classList.remove('is-updating');
          item.classList.add('is-removing');
          await new Promise(r => setTimeout(r, 370));
          item.remove();
        }
      } else {
        /* Mise à jour de la quantité et du prix dans le DOM */
        if (item) {
          item.classList.remove('is-updating');
          const qtyVal   = item.querySelector('[data-qty-value]');
          const linePrice = item.querySelector('[data-line-price]');
          const originalPrice = item.querySelector('[data-line-original-price]');
          const minusBtn  = item.querySelector('[data-qty-dir="minus"]');
          const plusBtn   = item.querySelector('[data-qty-dir="plus"]');

          if (qtyVal)    qtyVal.textContent      = qty;
          if (minusBtn)  minusBtn.dataset.qty     = qty - 1;
          if (plusBtn)   plusBtn.dataset.qty      = qty + 1;

          /* Mise à jour du prix de la ligne */
          const updatedItem = (!isNaN(line) && cart.items[line - 1])
            ? cart.items[line - 1]
            : cart.items.find(i => i.key === key);
          if (linePrice && updatedItem) {
            linePrice.textContent = formatMoney(updatedItem.line_price);
            if (originalPrice) {
              const hasDiscount = updatedItem.original_line_price > updatedItem.line_price;
              originalPrice.textContent = hasDiscount ? formatMoney(updatedItem.original_line_price) : '';
              originalPrice.style.display = hasDiscount ? '' : 'none';
              linePrice.classList.toggle('cart-page-item__line-price--deal', hasDiscount);
            }
          }

          /* Bouton − grisé si qty = 1 */
          if (minusBtn) minusBtn.disabled = qty - 1 < 1;
        }
      }

      /* Mettre à jour le récap, les barres et le compteur */
      animateShippingBar(threshold, cart.total_price);
      updateDiscountBar(cart.item_count);
      updateSummary(cart, threshold);
      updateCartCount(cart.item_count);

      /* Si panier vide → recharger pour afficher le panier vide */
      if (cart.item_count === 0) location.reload();

    } catch (err) {
      console.error('Cart update error:', err);
      if (item) item.classList.remove('is-updating');
    }
  });

  /* ── Suppression (bouton poubelle) ── */
  page.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;

    const key = removeBtn.dataset.cartRemove;
    const item = page.querySelector(`[data-cart-item][data-key="${key}"]`);
    if (item) item.classList.add('is-removing');

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      const cart = await res.json();

      await new Promise(r => setTimeout(r, 370));
      if (item) item.remove();

      animateShippingBar(threshold, cart.total_price);
      updateDiscountBar(cart.item_count);
      updateSummary(cart, threshold);
      updateCartCount(cart.item_count);

      if (cart.item_count === 0) location.reload();
    } catch (err) {
      console.error('Remove error:', err);
      if (item) item.classList.remove('is-removing');
    }
  });

  /* ── Code promo (toggle) ── */
  const promoToggle = page.querySelector('[data-promo-toggle]');
  const promoBody   = page.querySelector('[data-promo-body]');
  if (promoToggle && promoBody) {
    promoToggle.addEventListener('click', () => {
      const open = promoToggle.getAttribute('aria-expanded') === 'true';
      promoToggle.setAttribute('aria-expanded', String(!open));
      promoBody.hidden = open;
    });
  }

  /* ── Barre gamification remise ── */
  function updateDiscountBar(itemCount) {
    const container = page.querySelector('[data-discount-progress]');
    if (!container) return;

    const threshold = 3;
    const label     = container.querySelector('[data-discount-label]');
    const badge     = container.querySelector('[data-discount-badge]');
    const remaining = container.querySelector('[data-discount-remaining]');

    /* Mettre à jour les steps */
    for (let i = 1; i <= 3; i++) {
      const step = container.querySelector(`[data-step="${i}"]`);
      if (step) step.classList.toggle('is-filled', itemCount >= i);
      if (i < 3) {
        const connector = container.querySelector(`[data-connector="${i}"]`);
        if (connector) connector.classList.toggle('is-filled', itemCount > i);
      }
    }

    /* Badge actif */
    if (badge) badge.classList.toggle('is-active', itemCount >= threshold);

    /* Message */
    if (label) {
      if (itemCount >= threshold) {
        label.innerHTML = `<span class="discount-label--active">Votre remise de <strong>-10%</strong> est appliquée automatiquement à la commande !</span>`;
      } else {
        const left = threshold - itemCount;
        label.innerHTML = `Encore <strong>${left} article${left > 1 ? 's' : ''}</strong> pour bénéficier de <strong>-10%</strong> sur votre commande`;
      }
    }
  }

  /* ── Barre d'animation ── */
  function animateShippingBar(threshold, total) {
    const fill    = page.querySelector('[data-shipping-fill]');
    const label   = page.querySelector('[data-shipping-label]');
    const remaining = page.querySelector('[data-shipping-remaining]');
    const stickyTotal = page.querySelector('[data-sticky-total]');

    const freeShipAll = !!window._freeShipAll; // opération week-end
    const pct  = freeShipAll ? 100 : Math.min(100, Math.round((total / threshold) * 100));
    const left = Math.max(0, threshold - total);
    const freeAllLabel = `<span class="shipping-label--free">Livraison offerte sur <strong>toute votre commande</strong> ce week-end !</span>`;

    /* Légère pause pour que l'animation CSS soit visible */
    requestAnimationFrame(() => {
      if (fill) fill.style.width = pct + '%';

      /* Barre mobile identique */
      const fillMobile = page.querySelector('[data-shipping-fill-mobile]');
      if (fillMobile) fillMobile.style.width = pct + '%';
    });

    /* Desktop (dans le récap) */
    if (label) {
      if (freeShipAll) {
        label.innerHTML = freeAllLabel;
      } else if (pct >= 100) {
        label.innerHTML = `<span class="shipping-label--free">🎉 Vous bénéficiez de la <strong>livraison offerte</strong> !</span>`;
      } else if (remaining) {
        remaining.textContent = formatMoney(left);
      }
    }

    /* Mobile (barre dédiée) */
    const labelMobile = page.querySelector('[data-shipping-label-mobile]');
    const remainingMobile = page.querySelector('[data-shipping-remaining-mobile]');
    if (labelMobile) {
      if (freeShipAll) {
        labelMobile.innerHTML = freeAllLabel;
      } else if (pct >= 100) {
        labelMobile.innerHTML = `<span class="shipping-label--free">🎉 Vous bénéficiez de la <strong>livraison offerte</strong> !</span>`;
      } else if (remainingMobile) {
        remainingMobile.textContent = formatMoney(left);
      }
    }

    if (stickyTotal) stickyTotal.textContent = formatMoney(total);
  }

  /* ── Mise à jour du récap ── */
  function updateSummary(cart, threshold) {
    const subtotalEl  = page.querySelector('[data-summary-subtotal]');
    const totalEl     = page.querySelector('[data-summary-total]');
    const shippingEl  = page.querySelector('[data-summary-shipping]');
    const countEl     = page.querySelector('[data-cart-count]');
    const checkoutBtn = page.querySelector('[data-checkout-btn]');
    const stickyTotal = document.querySelector('[data-sticky-total]');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl)    totalEl.textContent    = formatMoney(cart.total_price);
    if (stickyTotal) stickyTotal.textContent = formatMoney(cart.total_price);

    if (countEl) {
      const n = cart.item_count;
      countEl.textContent = `(${n} article${n > 1 ? 's' : ''})`;
    }

    if (shippingEl) {
      if (window._freeShipAll || cart.total_price >= threshold) {
        shippingEl.innerHTML = `<em class="shipping-free-label">Offerte 🎉</em>`;
      } else {
        shippingEl.textContent = 'Calculée à la commande';
      }
    }
  }
}

/* ── Recherche Prédictive ────────────────────────────────────── */
function initPredictiveSearch() {
  const RECENT_KEY = 'themaya_recent_searches';
  const MAX_RECENT = 5;

  /* ---- helpers ---- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch { return []; }
  }
  function addRecent(term) {
    if (!term || term.length < 2) return;
    let list = getRecent().filter(t => t.toLowerCase() !== term.toLowerCase());
    list.unshift(term);
    list = list.slice(0, MAX_RECENT);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list));
  }
  function removeRecent(term) {
    const list = getRecent().filter(t => t !== term);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list));
  }
  function fmtPrice(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });
  }

  /* ---- open / close ---- */
  function openDropdown(dd) {
    dd.classList.add('is-open');
    dd.setAttribute('aria-hidden', 'false');
  }
  function closeDropdown(dd) {
    dd.classList.remove('is-open');
    dd.setAttribute('aria-hidden', 'true');
  }

  /* ---- render loading ---- */
  function renderLoading(dd) {
    dd.innerHTML = `<div class="search-dropdown__loading"><div class="search-spinner"></div> Recherche en cours…</div>`;
    openDropdown(dd);
  }

  /* ---- render recent searches ---- */
  function renderRecent(dd, input) {
    const list = getRecent();
    if (!list.length) { closeDropdown(dd); return; }

    const items = list.map((term, i) => `
      <div class="search-recent-item" data-recent-item="${i}" role="option" tabindex="-1">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.5"/>
        </svg>
        <span>${escapeHtml(term)}</span>
        <button class="search-recent-item__remove" data-remove-recent="${escapeHtml(term)}" aria-label="Supprimer">✕</button>
      </div>
    `).join('');

    dd.innerHTML = `
      <div class="search-dropdown__section-title">Recherches récentes</div>
      ${items}
    `;
    openDropdown(dd);

    /* clics sur items récents */
    dd.querySelectorAll('[data-recent-item]').forEach((el, i) => {
      el.addEventListener('click', (e) => {
        if (e.target.closest('[data-remove-recent]')) return;
        input.value = list[i];
        input.form.submit();
      });
    });

    /* suppression */
    dd.querySelectorAll('[data-remove-recent]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        removeRecent(btn.dataset.removeRecent);
        renderRecent(dd, input);
      });
    });
  }

  /* ---- render search results ---- */
  function renderResults(dd, products, articles, query) {
    if (!products.length && !articles.length) {
      dd.innerHTML = `
        <div class="search-dropdown__empty">
          <strong>Aucun résultat pour "${escapeHtml(query)}"</strong>
          Essayez un autre terme de recherche
        </div>`;
      openDropdown(dd);
      return;
    }

    /* ---- produits ---- */
    let productHtml = '';
    if (products.length) {
      const items = products.map(product => {
        const img = product.featured_image
          ? `<img class="search-result-item__img" src="${product.featured_image}" alt="${escapeHtml(product.title)}" loading="lazy">`
          : `<div class="search-result-item__img search-result-item__img--placeholder">
               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
             </div>`;
        const price = product.price ? fmtPrice(product.price) : '';
        const vendor = product.vendor ? `<span class="search-result-item__meta">${escapeHtml(product.vendor)}</span>` : '';

        return `
          <a class="search-result-item" href="${product.url}" role="option" tabindex="-1">
            ${img}
            <div class="search-result-item__info">
              <div class="search-result-item__title">${highlightMatch(product.title, query)}</div>
              ${vendor}
            </div>
            ${price ? `<div class="search-result-item__price">${price}</div>` : ''}
          </a>`;
      }).join('');
      productHtml = `<div class="search-dropdown__section-title">Produits</div>${items}`;
    }

    /* ---- articles ---- */
    let articleHtml = '';
    if (articles.length) {
      const items = articles.map(article => {
        const img = article.image
          ? `<img class="search-result-item__img" src="${article.image}" alt="${escapeHtml(article.title)}" loading="lazy">`
          : `<div class="search-result-item__img search-result-item__img--placeholder">
               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
             </div>`;
        return `
          <a class="search-result-item search-article-item" href="${article.url}" role="option" tabindex="-1">
            ${img}
            <div class="search-result-item__info">
              <span class="search-article-item__badge">Article</span>
              <div class="search-result-item__title">${highlightMatch(article.title, query)}</div>
            </div>
          </a>`;
      }).join('');
      articleHtml = `<div class="search-dropdown__section-title search-dropdown__section-title--articles">Guide du Thé</div>${items}`;
    }

    dd.innerHTML = `
      ${productHtml}
      ${articleHtml}
      <div class="search-dropdown__footer">
        <a class="search-dropdown__see-all" href="/search?q=${encodeURIComponent(query)}">
          Voir tous les résultats pour « ${escapeHtml(query)} »
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </a>
      </div>`;
    openDropdown(dd);
  }

  /* ---- highlight matching text ---- */
  function highlightMatch(text, query) {
    if (!query) return escapeHtml(text);
    const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    return escapeHtml(text).replace(regex, '<mark style="background:rgba(45,90,61,0.12);color:inherit;border-radius:2px;padding:0 1px">$1</mark>');
  }

  /* ---- keyboard navigation ---- */
  function handleKeyboard(e, dd, input) {
    const items = [...dd.querySelectorAll('.search-result-item, .search-recent-item, .search-article-item')];
    if (!items.length) return;

    const focused = dd.querySelector('.is-focused');
    let idx = focused ? items.indexOf(focused) : -1;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      idx = (idx + 1) % items.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      idx = (idx - 1 + items.length) % items.length;
    } else if (e.key === 'Enter' && focused) {
      e.preventDefault();
      if (focused.tagName === 'A') { window.location.href = focused.href; }
      else { focused.click(); }
      return;
    } else if (e.key === 'Escape') {
      closeDropdown(dd);
      input.blur();
      return;
    } else { return; }

    items.forEach(el => el.classList.remove('is-focused'));
    items[idx].classList.add('is-focused');
    items[idx].scrollIntoView({ block: 'nearest' });
  }

  /* ---- escape HTML ---- */
  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ---- parse le prix retourné par l'API Shopify (en centimes pour fmtPrice) ---- */
  function parseShopifyPrice(val) {
    if (val == null) return null;
    const str = String(val).trim();
    const num = parseFloat(str);
    if (isNaN(num) || num === 0) return null;
    /* Si la valeur contient un point décimal → c'est déjà en euros (ex: "12.99")
       On convertit en centimes pour fmtPrice */
    if (str.includes('.')) return Math.round(num * 100);
    /* Sinon c'est déjà en centimes (ex: "1200") */
    return Math.round(num);
  }

  /* ---- fetch from Shopify Predictive Search API ---- */
  const cache = new Map();
  async function fetchResults(query, dd) {
    renderLoading(dd);
    const q = query.trim();
    if (cache.has(q)) { const c = cache.get(q); renderResults(dd, c.products, c.articles, q); return; }

    try {
      const urlProducts = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[fields]=title,body,tag,product_type,vendor,variants.title,variants.sku`;
      const urlArticles = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=article&resources[limit]=3`;

      const [resP, resA] = await Promise.all([fetch(urlProducts), fetch(urlArticles)]);

      const dataP = resP.ok ? await resP.json() : {};
      const dataA = resA.ok ? await resA.json() : {};

      const rawProducts = dataP.resources?.results?.products || [];
      const rawArticles = dataA.resources?.results?.articles || [];

      /* Normalise les produits */
      const products = rawProducts.map(p => ({
        title:          p.title  || '',
        url:            p.url    || `/products/${p.handle}`,
        vendor:         p.vendor || '',
        featured_image: p.featured_image?.url || p.featured_image || p.image || null,
        price: parseShopifyPrice(p.price_min ?? p.price)
      }));

      /* Normalise les articles */
      const articles = rawArticles.map(a => ({
        title: a.title || '',
        url:   a.url   || `/blogs/guide-du-the/${a.handle}`,
        image: a.image?.url || a.featured_image?.url || a.featured_image || null
      }));

      cache.set(q, { products, articles });
      renderResults(dd, products, articles, q);
    } catch (err) {
      console.error('Predictive search error:', err);
      dd.innerHTML = `<div class="search-dropdown__empty"><strong>Erreur de recherche</strong>Veuillez réessayer.</div>`;
    }
  }

  /* ---- init each form ---- */
  document.querySelectorAll('[data-search-form]').forEach(form => {
    const input = form.querySelector('[data-search-input]');
    const dd = form.querySelector('[data-search-dropdown]');
    if (!input || !dd) return;

    let debounceTimer;

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const q = input.value.trim();
      if (q.length >= 2) {
        debounceTimer = setTimeout(() => fetchResults(q, dd), 280);
      } else if (q.length === 0) {
        debounceTimer = setTimeout(() => renderRecent(dd, input), 100);
      } else {
        closeDropdown(dd);
      }
    });

    input.addEventListener('focus', () => {
      const q = input.value.trim();
      if (q.length >= 2) {
        fetchResults(q, dd);
      } else {
        renderRecent(dd, input);
      }
    });

    input.addEventListener('keydown', (e) => handleKeyboard(e, dd, input));

    form.addEventListener('submit', () => {
      addRecent(input.value.trim());
    });

    /* Fermer au clic extérieur */
    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) closeDropdown(dd);
    }, { passive: true });
  });
}

/* ── Variant Selector (option-based, dynamic price + stock) ──── */
(function () {
  const variantsEl = document.getElementById('product-variants-json');
  if (!variantsEl) return;

  let variants;
  try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

  // Track selected options: { 0: 'Pochette 50g', 1: ... }
  const selectedOptions = {};

  // Init from active buttons
  document.querySelectorAll('.variant-btn.active').forEach(btn => {
    selectedOptions[btn.dataset.optionIndex] = btn.dataset.value;
  });

  function findMatchingVariant() {
    return variants.find(v => {
      return Object.entries(selectedOptions).every(([idx, val]) => {
        return v['option' + (parseInt(idx) + 1)] === val;
      });
    }) || null;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 2
    });
  }

  function updateUI(variant) {
    if (!variant) return;

    // Prix
    const priceEl = document.getElementById('product-price');
    const compareEl = document.getElementById('product-compare-price');
    const isCse = priceEl && priceEl.classList.contains('product-info__price--cse');

    if (isCse) {
      const csePrice = Math.round(variant.price * 0.7);
      if (priceEl) priceEl.textContent = formatMoney(csePrice);
      if (compareEl) { compareEl.textContent = formatMoney(variant.price); compareEl.style.display = ''; }
    } else {
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
    }

    // Badge stock
    const badge = document.getElementById('product-stock-badge');
    if (badge) {
      badge.textContent = variant.available ? 'En stock' : 'Rupture de stock';
      badge.classList.toggle('stock-badge--out', !variant.available);
    }

    // Bouton ATC
    const atcBtn = document.getElementById('product-atc');
    if (atcBtn) {
      atcBtn.dataset.atc = variant.id;
      atcBtn.disabled = !variant.available;
      atcBtn.innerHTML = variant.available
        ? `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> AJOUTER AU PANIER`
        : 'RUPTURE DE STOCK';
    }

    // Griser les boutons d'option incompatibles
    document.querySelectorAll('.variant-btn').forEach(btn => {
      const testOptions = { ...selectedOptions, [btn.dataset.optionIndex]: btn.dataset.value };
      const exists = variants.some(v =>
        Object.entries(testOptions).every(([idx, val]) => v['option' + (parseInt(idx) + 1)] === val)
      );
      btn.disabled = !exists;
      btn.style.opacity = exists ? '' : '0.35';
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.variant-btn');
    if (!btn) return;

    const idx = btn.dataset.optionIndex;
    const val = btn.dataset.value;

    // Active state dans le groupe
    const group = btn.closest('.variant-buttons');
    if (group) {
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    }

    selectedOptions[idx] = val;
    const match = findMatchingVariant();
    if (match) updateUI(match);
  });
})();

/* ── Personnalisation bouteille ──────────────────────────────── */
(function () {
  const toggle  = document.getElementById('perso-toggle');
  const panel   = document.getElementById('perso-panel');
  const textInput = document.getElementById('perso-text');
  const countEl  = document.getElementById('perso-count');
  const previewEl = document.getElementById('perso-preview-text');
  const fontBtns  = document.querySelectorAll('.perso-font-btn');
  const atcBtn    = document.getElementById('product-atc');

  if (!toggle || !panel) return;

  // ── Polices Google Fonts (chargées une seule fois) ─────────────
  const FONTS = ['Dancing+Script', 'Great+Vibes', 'Pacifico', 'Playfair+Display', 'Raleway'];
  const link = document.createElement('link');
  link.rel  = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?${FONTS.map(f => `family=${f}:wght@400;700`).join('&')}&display=swap`;
  document.head.appendChild(link);

  let selectedFont = 'Dancing Script';

  // ── Toggle ouverture / fermeture ──────────────────────────────
  toggle.addEventListener('click', () => {
    const isOpen = !panel.hidden;
    panel.hidden = isOpen;
    toggle.classList.toggle('perso-toggle--active', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));

    // Mise à jour du label et du prix du bouton ATC
    updateAtcLabel(!isOpen);
  });

  // ── Saisie texte → aperçu ────────────────────────────────────
  if (textInput) {
    textInput.addEventListener('input', () => {
      const val = textInput.value;
      countEl && (countEl.textContent = val.length);
      renderPreview(val, selectedFont);
    });
  }

  // ── Sélecteur de police ──────────────────────────────────────
  fontBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      fontBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      selectedFont = btn.dataset.font;
      renderPreview(textInput ? textInput.value : '', selectedFont);
    });
  });

  // ── Rendu aperçu ─────────────────────────────────────────────
  function renderPreview(text, font) {
    if (!previewEl) return;
    const isPlaceholder = !text.trim();
    const display = text.trim() || 'Votre texte';
    previewEl.textContent = display;
    previewEl.style.fontFamily = `'${font}', cursive, serif`;
    // SVG <text> : fill via attribut (le dégradé inox ou semi-transparent)
    if (isPlaceholder) {
      previewEl.setAttribute('fill', 'rgba(255,255,255,0.28)');
      previewEl.style.fontStyle = 'italic';
    } else {
      previewEl.setAttribute('fill', 'url(#inoxTextGrad)');
      previewEl.style.fontStyle = 'normal';
    }
  }

  // ── Mise à jour bouton ATC ───────────────────────────────────
  function updateAtcLabel(persoActive) {
    if (!atcBtn) return;
    const priceEl = document.getElementById('product-price');
    const basePrice = priceEl ? priceEl.dataset.basePrice : null;

    if (persoActive) {
      atcBtn.dataset.persoActive = '1';
    } else {
      delete atcBtn.dataset.persoActive;
    }
  }

  // Init aperçu
  renderPreview('', selectedFont);
})();
